import { API_BASE_URL } from "../config/apiConfig";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";

function FacilityLogin() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setError("");
    setIsSubmitting(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: formData.email,
            password: formData.password,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Unable to sign in.");
      }

      const token = data.token;
      const user = data.user;

      if (!token || !user) {
        throw new Error("The login response is missing user information.");
      }

      if (user.role?.toLowerCase() !== "facility") {
        throw new Error("This account is not registered as a facility.");
      }

      localStorage.setItem("zethAuthToken", token);
      localStorage.setItem("zethUser", JSON.stringify(user));

      navigate("/facility/dashboard", { replace: true });
    } catch (loginError) {
      console.error("Facility login error:", loginError);
      setError(loginError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="Reliable staffing starts here."
      description="Sign in to request qualified professionals, manage assignments and communicate with the Zeth Health team."
    >
      <div className="auth-card">
        <p className="account-label">Healthcare facilities</p>
        <h2>Facility Login</h2>

        {error && <p className="form-error">{error}</p>}

        <form className="account-form" onSubmit={handleSubmit}>
          <label htmlFor="facility-email">Work email address</label>
          <input
            id="facility-email"
            name="email"
            type="email"
            placeholder="name@facility.ca"
            autoComplete="email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <label htmlFor="facility-password">Password</label>
          <input
            id="facility-password"
            name="password"
            type="password"
            placeholder="Enter your password"
            autoComplete="current-password"
            value={formData.password}
            onChange={handleChange}
            required
          />

          <div className="form-options">
            <label className="remember-option">
              <input type="checkbox" />
              Remember me
            </label>

            <Link to="/facility/forgot-password">
              Forgot password?
            </Link>
          </div>

          <button
            className="primary-button auth-submit"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="account-links auth-account-links">
          <span>New facility partner?</span>
          <Link to="/facility/register">Create an account</Link>
        </div>

        <Link className="return-home-link" to="/">
          ← Return to homepage
        </Link>
      </div>
    </AuthLayout>
  );
}

export default FacilityLogin;
